import { State } from '@cemex/cmx-client-layout';
import { createFeatureSelector } from '@ngrx/store';
import * as fromCxShippingConditions from './cx-shipping-condition.reducer';

export const cxShippingConditionKey = 'cxShippingConditions';
export const reducers = fromCxShippingConditions.reducer;

export interface CxShippingConditionsState extends State {
  [cxShippingConditionKey]: fromCxShippingConditions.CxShippingConditionState;
}

export const selectShippingConditionsState =
  createFeatureSelector<fromCxShippingConditions.CxShippingConditionState>(cxShippingConditionKey);
